module.exports = __webpack_public_path__ + "static/alabi-2f0e0882fe91356be2b2e7578fb7c968.png";